import script from "./EmailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailModal.vue?vue&type=script&lang=ts&setup=true"

import "./EmailModal.vue?vue&type=style&index=0&id=ada3ddd0&lang=scss"

const __exports__ = script;

export default __exports__